import {loader, isLoading} from '../utils/loader';
import Network from '../utils/network';
import formSerializeObject from '../utils/form-serialize-object';
// import modalThanks from '../common/modal-thanks';
import Notice from './notice';
// import addEcommerceData from './ecommerce';
import addAnalyticsForm from './analytics-form';
import recaptchaInit from './recaptcha';
import RedirectForm from './redirect-form';

/**
 * Sender form
 * @typedef {SubmitHandler} SubmitHandler
 */
class SubmitHandler {
    modal;
    form;
    action;
    formData;
    analytics;
    placeId;
    files;
    formRedirect;

    /**
     * Constructor
     * @param {Modal} modal
     * @param {HTMLFormElement} form
     * @param {Object} analytics
     * @param {Number} placeId
     * @param {Object} files
     */
    constructor({modal, form, analytics = {}, placeId, files = {}}) {
        this.modal = modal;
        this.form = form;
        this.action = form.action;
        this.analytics = analytics;
        this.placeId = placeId;
        this.files = files;
        this.formRedirect = new RedirectForm(modal);

        if (!isLoading()) {
            this.render().then(() => {
                this.setFormData();
                this.sendRequest();
            });
        }
    }

    /**
     * Static run
     * @param {Object} data
     * @returns {SubmitHandler}
     */
    static run(data) {
        return new SubmitHandler(data);
    }

    static getTitlePage() {
        const elemH1 = document.querySelector('h1');
        let title = elemH1 ? elemH1.textContent : '';

        if (!title) {
            const inputElem = document.querySelector('.search-form .search-input');
            const inputVal = inputElem ? inputElem.value : '';

            if (inputVal) {
                title = `Поиск - ${inputVal}`;
            }

            if (!title) {
                title = document.title;
            }
        }

        return title.trim();
    }

    /**
     * Data from form
     */
    setFormData() {
        this.formData = Object.assign({},
            {
                pageUrl: window.location.href,
                pageTitle: SubmitHandler.getTitlePage(),
                files: this.files,
            },
            formSerializeObject(null, this.form),
        );
    }

    /** Success action */
    showSuccess() {
        this.form.reset();

        if (this.modal.selectors.elemCall !== '[data-content-form]') {
            this.modal.destroy();
        }

        $('#thanksModal').foundation('open');
    }

    /**
     * Action network
     */
    sendRequest() {
        Network.call({
            link: this.action,
            data: this.formData,
            method: 'POST',
        }).then((r) => {
            let {error, messages} = r;

            if (error === false) {
                // addEcommerceData(product);
                addAnalyticsForm(this.analytics);

                if (this.formRedirect.status) {
                    this.formRedirect.render(this.formData);
                } else {
                    this.showSuccess();
                }
            } else if (error === true) {
                Notice.execute('acceptFail', {
                    form: this.form,
                    messages,
                });
            } else {
                Notice.execute('processFail', {form: this.form});
            }
        }).finally(() => {
            loader(false);
        }).catch((e) => {
            Notice.execute('processFail', {form: this.form});
            throw new SyntaxError(e);
        });
    }

    /**
     * Render submit
     * @returns {Promise<void>}
     */
    async render() {
        loader(true);
        Notice.execute('clear', {form: this.form});

        await recaptchaInit(this.modal.activeModal);
    }
}

export default SubmitHandler;
